import { UploadImg } from './../../model/OtherModel/OtherModel';
import HttpClient from '@chehejia/club-lib/lib/httpUtils/HttpClient';
import Constants from '../../enum/Constants';
import axios from 'axios';

export default class OtherService {
    public static params: any = {
        identify: 'lixiangzhizao_app',
        durationSeconds: '900',
        bucketType: '1',
        stsType: '1',
    };

    public static oasParams: any = {
      appId: 'aisp_community',
      ueType: 2,
      durationSeconds: 3600,
  };

    // // 申请临时授权-写（阿里云图片上传）
    // public static getStsWrite() {
    //     this.params.bucketType = 1;
    //     return HttpClient.get(Constants.getOisSts(), '/write', { params: this.params }).then((data) => {
    //         console.log('参数', this.params, data);
    //         return data;
    //     });
    // }

    // 申请临时授权-写（阿里云图片上传）(oas新接口)
    public static getStsWrite() {
        this.params.bucketType = 1;
        return HttpClient.get(Constants.getOasSts(), '/os/sts/write', { params: this.oasParams , headers:{
          'Authorization': `Bearer ${localStorage.getItem("img-access_token")}` || ''
        }}).then((data) => {
            console.log('写参数', this.params, data);
            return data;
        });
    }

    // 申请临时授权-读（阿里云图片上传）(oas新接口)
    public static getStsRead(file) {
      this.params.bucketType = 1;
      const params = this.oasParams
      params.fileKey = file
      return HttpClient.get(Constants.getOasSts(), '/os/token/read', { params , headers:{
        'Authorization': `Bearer ${localStorage.getItem("img-access_token")}` || ''
      } }).then((data) => {
          console.log('读参数', this.params, data);
          return data;
      });
  }

      // 获取百度bos云图片信息Url
      public static GetStsBosImgInfo(file: string) {
        this.params.bucketType = 1;
      const params = this.oasParams
      params.fileKey = file
      params.params = 'exif='
      return HttpClient.get(Constants.getOasSts(), '/os/stsPreSignedtoken/read', { params , headers:{
        'Authorization': `Bearer ${localStorage.getItem("img-access_token")}` || ''
      } }).then((data) => {
          return data;
      });
    }

    // 获取百度bos云图片信息Url
    public static GetStsBosImgInfoUrl(imgUrl: string) {
    return axios.get(imgUrl)
  }

    // // 申请临时授权-写（vod视频上传）
    // public static getStsVodUpload() {
    //     console.log('shangchuan'); // 需要修改接口
    //     this.params.bucketType = 5;
    //     return HttpClient.get(Constants.getOisSts(), '/vod/upload', { params: this.params }).then((data) => {
    //         return data;
    //     });
    // }

    // 申请临时授权-写（vod视频上传）(oas新接口)
    public static getStsVodUpload() {
      // this.params.bucketType = 5;
      return HttpClient.get(Constants.getOasSts(), '/vod/sts/write', { params: this.oasParams , headers:{
        'Authorization': `Bearer ${localStorage.getItem("img-access_token")}` || ''
      } }).then((data) => {
          return data;
      });
  }

    // 申请临时授权-查询截图数据
    public static getSnapshots(videoId) {
        const param = {
            identify: 'lixiangzhizao_app',
            videoId,
        };
        return HttpClient.get(Constants.getOisSts(), '/vod/snapshots', { params: param }).then((data) => {
            return data;
        });
    }

    // 申请临时授权-查询视频数据
    public static getPlayInfo(videoId) {
        const param = {
            identify: 'lixiangzhizao_app',
            videoId,
        };
        return HttpClient.get(Constants.getOisSts(), '/vod/playInfo', { params: param }).then((data) => {
            return data;
        });
    }

    // 图片上传
    public static uploadImg(param) {
        return HttpClient.post(Constants.getcommunityComm(), '/uploadSImg', param).then((data) => {
            return data;
        });
    }

    // 获取阿里云图片信息
    public static GetImgInfo(imgUrl: string) {
        imgUrl = imgUrl.indexOf('http:') > -1 && imgUrl.replace('http:', 'https:') || imgUrl;
        return HttpClient.get(imgUrl + '?x-oss-process=image/info', '').then((data) => {
            return data;
        });
    }

    // 获取百度bos云图片信息
    public static GetBosImgInfo(imgUrl: string) {
        const config = { withCredentials: false };
        imgUrl = imgUrl.indexOf('http:') > -1 && imgUrl.replace('http:', 'https:') || imgUrl;
        return HttpClient.get(imgUrl + '?exif', '', config).then((data) => {
            return data;
        });
    }
    public static getGroupList(accountId: string) {
        return HttpClient.get(Constants.getCommunity(), '/group/pc/join', {params: {accountId}}).then((data) => {
            return data;
        });
    }

}
